import React, { useState, useContext } from 'react';
import '../../../../utils/date';
import { toast } from 'react-toastify';
import FilterIcon from '../../../../icons/FilterIcon';
import PlusIcon from '../../../../icons/PlusIcon';
import UpIcon from '../../../../icons/UpIcon';
import excelLogo from '../../../../assets/excel-logo.png';
import { Modal } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import DebouncedTextField from '../../../../components/common/DebouncedTextField';
import ContributorsForm from './ContributorsForm';
import ORBApi from '../../../../services/ORBApi';
import SessionContext from '../../../../contexts/SessionContext';

export const defaultFilters = {
  term: '',
};

const ActionBar = (props) => {
  const [showFilters, showHideFilters] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const [importing, setImporting] = useState(false);
  let { hasRole } = useContext(SessionContext);

  const messages = props.messages || {};

  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    props.onFilterChange(newFilters);
  };

  const onTermChangeHandler = (term) => {
    updateFilters({ ...filters, term: term });
  };

  const downloadContributors = () => {
    ORBApi.downloadContributors()
      .then((data) => {
        const file = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(file);
        link.download = 'ORB-titulares.xlsx';
        link.click();
        toast.success(messages.downloaded_file || 'Arquivo exportado');
      })
      .catch(() => toast.error(messages.error || 'Erro ao exportar'));
  };

  const openImportPicker = () => {
    document.getElementById('contributors-file-input').click();
  };

  const importContributors = () => {
    const input = document.getElementById('contributors-file-input');
    const file = input.files[0];
    if (!file) return;

    setImporting(true);
    const formData = new FormData();
    formData.append('contributors_file', file);

    ORBApi.importContributors(formData)
      .then((res) => {
        const s = res && res.summary;
        if (s) {
          toast.success(
            (messages.import_summary ||
              'Importação: {updated} atualizados, {created} criados, {errors} com erro')
              .replace('{updated}', s.updated)
              .replace('{created}', s.created)
              .replace('{errors}', s.errors),
          );
        } else {
          toast.success(messages.success_upload || 'Importação concluída');
        }
        if (props.onImported) props.onImported();
      })
      .catch(() => toast.error(messages.import_error || 'Falha na importação'))
      .finally(() => {
        input.value = '';
        setImporting(false);
      });
  };

  return (
    <>
      <div className="page-actionbar-container">
        <div
          className="page-actionbar-item action-btn"
          onClick={() => showHideFilters(!showFilters)}
        >
          <FilterIcon />
        </div>
        {hasRole(['CONTRIBUTORS_WRITE']) ? (
          <>
            <div
              className="page-actionbar-item action-btn"
              onClick={() => {
                props.setFormVisible(true);
              }}
            >
              <PlusIcon />
            </div>
            <div
              className="page-actionbar-item action-btn"
              title={props.import_title || 'Importar titulares'}
              onClick={openImportPicker}
            >
              <UpIcon />
            </div>
            <input
              type="file"
              id="contributors-file-input"
              accept=".xls,.xlsx"
              hidden="hidden"
              onChange={importContributors}
            />
            <div
              className="action-btn"
              title={props.export_title || 'Exportar titulares'}
              onClick={downloadContributors}
            >
              <img
                src={excelLogo}
                style={{ height: '25px', margin: '0 10px' }}
                alt="Exportar titulares"
              />
            </div>
          </>
        ) : null}

        <div className="page-actionbar-item" style={{ marginLeft: 'auto' }}>
          <h5>
            {props.total_holders}: {props.total_items}
          </h5>
        </div>
        <div>
          <Modal
            size="lg"
            open={props.formVisible}
            onClose={() => props.setFormVisible(!props.formVisible)}
            slotsbackdropprops={Backdrop}
            slotsbackdropprops={{ timeogut: 500 }}
          >
            <div className="modal-container">
              <ContributorsForm
                form_texts={props.form_texts}
                messages={messages}
                setFormVisible={props.setFormVisible}
                onSaveContributor={props.onSaveContributor}
              />
            </div>
          </Modal>
        </div>
      </div>
      {showFilters ? (
        <div className="page-filter-bar">
          <DebouncedTextField
            label={props.input_filter}
            onChange={(value) => {
              onTermChangeHandler(value);
            }}
          />
        </div>
      ) : null}
    </>
  );
};

export default ActionBar;
